// AssetCardList.jsx
import React from "react";
import AssetCard from "./AssetCard";
import { VscPreview } from "react-icons/vsc";
const AssetCardList = ({ assets,onCopy, onEdit, onDelete,setShowPreview }) => {
  return (
    <div className="card">
      <div className="p-2 border-bottom">
        <h5 className="m-0">Added Assets</h5>
        <span className="text-dark fw-medium" style={{ fontSize: "0.8rem" }}>
          {assets.length} items added
        </span>
      </div>
      <div className="card-body p-2">
        <div
          className="d-flex flex-column gap-2 scroll-container"
          style={{ maxHeight: "400px", overflowY: "auto" }}
        >
          {assets.length == 0 && (
            <div className="text-center fw-medium text-dark my-2">
              No Asset Added
            </div>
          )}
          {assets.map((asset, index) => (
            <AssetCard
              key={index}
              asset={asset}
              assetIndex={index}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          ))}
        </div>
      </div>
      <div className="border-top p-3 text-center">
        <span className="text-info fw-medium cursor-pointer" onClick={()=>setShowPreview(true)}><VscPreview className="me-1"/>Preview</span>
      </div>
    </div>
  );
};

export default AssetCardList;
